import { useRouteData } from "@solidjs/router";
import { Component, Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { loadAds, loadOtherAwardsCms, setPageTitle, setSubMenu } from "../../app";
import { CMS } from "../../components/cms/cms";
import { SalonSubmissionAwardGrouping } from "../../Types";
import { AwardGroupingList } from "../../components/artwork-grouping-list";
import { RunnerUp } from "../../components/runner-up";
import { ScrollToTarget } from "../../components/scroll-to-target";
import { cleanTargetName } from "../../library/common";

type State =  {
    isContentReady: boolean;
}

const Heading : Component<any> = (props) => {
    return (
        <>
            <div class="white-divider" style="background-color: #fff;">
                <div class="container" style="text-align: center;">
                    <h3 style="font-family: 'Gill Sans MT'; font-size: 4em;">
                        {props.children}
                    </h3>
                </div>
            </div>
        </>
    )
}

type AwardLinkProps = {
    id: string;
    children: string;
}

const AwardLink : Component<AwardLinkProps> = (props) =>
<span class="award-link" data-target={cleanTargetName(props.children)}>
    <CMS text id={props.id}>{props.children}</CMS>
</span>;

export function OtherAwardsPage() {
    const [grouping, setGrouping] = createStore<SalonSubmissionAwardGrouping[]>([]);
    const [state, setState] = createStore<State>({ isContentReady: false });
    const getItems = (award: string) => grouping.filter(x=> x.Award.indexOf(award) >= 0);
    onMount(async() => {
        const routeData = await useRouteData() as any;
        setGrouping(routeData.grouping);
        await loadOtherAwardsCms();
        await loadAds("8th-arc-salon/introduction");
        setPageTitle({ id: "8th-arc-salon/other-awards::title", text: "Other Awards" });
        setSubMenu("Other Awards");
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <ScrollToTarget selector=".award-link" nextElementSiblingOffset={0}>
                    <div>
                        <div class="category-intro">
                            <div>
                                <div style="padding: 0 40px; text-align: center;">
                                    <div style="display: inline-block; margin-right: 40px; text-align: left; vertical-align: top;">
                                        <ul>
                                            <li style="list-style: none;">
                                                <h3 style="font-family: 'Oswald'; font-size: 2em;">
                                                    <AwardLink id="8th-arc-salon/other-awards::heading/other-awards">Other Awards</AwardLink>
                                                </h3>
                                                <hr />
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/arc-purchase-awards">ARC Purchase Awards</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/most-ambitious">Most Ambitious</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/most-creative">Most Creative</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/best-portrait">Best Portrait</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/best-social-commentary">Best Social Commentary</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/best-trompe-loeil">Best Trompe L'oeil</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/chairmans-choice-awards">Chairman's Choice Awards</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="8th-arc-salon/other-awards::heading/arc-staff-awards">ARC Staff Awards</AwardLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AwardGroupingList
                        items={getItems("ARC Purchase")}
                        showPrizeMoney={true} showDivider={true}
                        heading="ARC Purchase Awards"
                    />
                    <RunnerUp baseAwardName="Most Ambitious" model={grouping} />
                    <RunnerUp baseAwardName="Most Creative" model={grouping} />
                    <RunnerUp baseAwardName="Best Portrait" model={grouping} />
                    <RunnerUp baseAwardName="Best Social Commentary" model={grouping} />
                    <RunnerUp baseAwardName="Best Trompe L'oeil" model={grouping} />
                    <AwardGroupingList
                        items={getItems("Chairman")}
                        showDivider={true}
                        heading="Chairman's Choice Awards"
                    />
                    <AwardGroupingList
                        items={getItems("ARC Staff")}
                        showDivider={true}
                        heading="ARC Staff Awards"
                    />
                </ScrollToTarget>
            </Show>
        </>
    )
}